/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The EmailsImportsBody model module.
 * @module model/EmailsImportsBody
 * @version 1.0.0
 */
export class EmailsImportsBody {
  /**
   * Constructs a new <code>EmailsImportsBody</code>.
   * @alias module:model/EmailsImportsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EmailsImportsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EmailsImportsBody} obj Optional instance to populate.
   * @return {module:model/EmailsImportsBody} The populated <code>EmailsImportsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EmailsImportsBody();
      if (data.hasOwnProperty('emails'))
        obj.emails = ApiClient.convertToType(data['emails'], ['String']);
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
      if (data.hasOwnProperty('fieldsMap'))
        obj.fieldsMap = ApiClient.convertToType(data['fieldsMap'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Array.<String>} emails
 */
EmailsImportsBody.prototype.emails = undefined;

/**
 * @member {Blob} file
 */
EmailsImportsBody.prototype.file = undefined;

/**
 * @member {String} fieldsMap
 */
EmailsImportsBody.prototype.fieldsMap = undefined;

